// extracted by mini-css-extract-plugin
export default {"container":"ProTip_container__08zVG","title":"ProTip_title__oDhCL","subTitle":"ProTip_subTitle__FtzDG"};